import object from '@mailobj-browser/front/js/utils/object.js'

export default object(null, {
  m: 60,
  h: 3600,
  d: 86400
})